/**
 * HTTP status error messages
 * Extracted from constants.ts to reduce file size
 */

import { PAYLOAD_TOO_LARGE_USER_MESSAGE } from "@Front/Utils/sanitizeApiErrorBodyForUser";
import { getUploadTextScope } from "@Front/Components/DesignSystem/helpers/fileUploadUiI18n";
import type { UserFriendlyError } from "../types";

/**
 * Messages d'erreur par code HTTP
 */
export const HTTP_STATUS_MESSAGES: Record<number, UserFriendlyError> = {
	400: {
		title: "Informations invalides",
		message: "Certaines informations sont incorrectes. Veuillez vérifier et réessayer.",
		canRetry: true,
	},
	/** Affichage utilisateur : `handleHttpStatusError` remplace par `site_texts` (`login.error.http401.*`). */
	401: {
		title: "Accès refusé",
		message: "Vous n'avez pas les droits nécessaires pour effectuer cette action. Vérifiez vos permissions ou contactez votre administrateur.",
		canRetry: false,
	},
	403: {
		title: "Action interdite",
		message: "Cette action n'est pas autorisée pour votre compte. Votre rôle ne vous permet pas d'effectuer cette opération.",
		canRetry: false,
	},
	404: {
		title: "Élément introuvable",
		message: "L'élément demandé n'existe pas ou a été supprimé.",
		canRetry: false,
	},
	409: {
		title: "Conflit détecté",
		message: "Cette action entre en conflit avec des données existantes.",
		canRetry: true,
	},
	413: {
		title: getUploadTextScope("sendDocuments").tooLargeTitle,
		message: PAYLOAD_TOO_LARGE_USER_MESSAGE,
		canRetry: true,
	},
	429: {
		title: "Trop de tentatives",
		message: "Vous avez effectué trop de requêtes. Veuillez patienter quelques instants.",
		canRetry: true,
	},
	500: {
		title: "Erreur serveur",
		message: "Une erreur s'est produite sur nos serveurs. Notre équipe technique a été notifiée.",
		canRetry: true,
	},
	503: {
		title: "Service temporairement indisponible",
		message: "Le service est momentanément indisponible. Veuillez réessayer dans quelques instants.",
		canRetry: true,
	},
};

